import { Builder } from '@builder.io/react';

import Example from './index.tsx';

Builder.registerComponent(Example, {
  name: 'Example',
  inputs: [
    {
      name: 'tabs',
      type: 'list',
      subFields: [
        {
          name: 'title',
          type: 'string',
          defaultValue: 'Forge',
          enum: ['Forge', 'Attribute Enrichment', 'Matching']
        }
      ]
    }
  ]
});
